module.exports = __webpack_public_path__ + "static/img/08102807ur4j.bfca1f80.jpg";